import { gql } from 'graphql-request';

export const FEEDBACK_FIELDS = gql`
  fragment FeedbackFields on FeedbackDto {
    feedbackId
    userId
    rating
    comment
    type
    metadata
    createdAt
    user {
      userId
      firstName
      lastName
      email
    }
  }
`;

const getAllFeedback = gql`
  query getAllFeedback {
    getAllFeedback {
      ...FeedbackFields
    }
  }

  ${FEEDBACK_FIELDS}
`;

const getPaginatedFeedback = gql`
  query getPaginatedFeedback($criteria: GetPaginatedFeedbackInput!) {
    getPaginatedFeedback(criteria: $criteria) {
      feedbacks {
        ...FeedbackFields
      }
      count
    }
  }

  ${FEEDBACK_FIELDS}
`;

const createFeedback = gql`
  mutation createFeedback($feedback: CreateFeedbackDto!) {
    createFeedback(feedback: $feedback) {
      ...FeedbackFields
    }
  }

  ${FEEDBACK_FIELDS}
`;

const FeedbackGraphQL = {
  queries: {
    getAllFeedback,
    getPaginatedFeedback,
  },
  mutations: {
    createFeedback,
  },
};

export default FeedbackGraphQL;
